import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ListGroup} from "@app/core/lists/domain/list-group";
import {List} from "@app/core/lists/domain/list";
import {Product} from "@app/core/product/domain/dtos/product";
import {ListDetail} from "./list-detail";

@Injectable({
    providedIn: 'root'
})
export abstract class ListRemote {

    public abstract getListGroups(): Observable<ListGroup[]>;

    public abstract addProductToList(listId: number, productCode: string, quantity: number): Observable<List>;

    public abstract deleteProductFromList(listId: number, productCode: string): Observable<List>;

    public abstract createList(name: string, recaptchaToken: string, productsCodes: string[]): Observable<List>;

    public abstract createListWithProducts(name: string, productsCodes: string[]): Observable<List>;

    public abstract renameList(listId: number, newName: string): Observable<List>;

    public abstract deleteList(listId?: number): Observable<void>;

    public abstract getList(listCode: number): Observable<ListDetail>;

    public abstract getUsualPurchase(withStockAvailability: boolean): Observable<ListDetail>;

    public abstract getFavoriteProducts(itemsPerPage: number, page: number): Observable<Product[]>

}
